import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HomeCategoryMain from "../Components/Home Category/viewHomeCategory";
// import AddHomeCategory from "../Components/Home Category/addHomeCategory";
// import ViewHomeCategory from "../Components/Home Category/viewHomeCategory";

const HomeCategoryRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");

  return (
    <Routes>
      <Route path="/home_category" element={<HomeCategoryMain />} />
    </Routes>
  );
};

export default HomeCategoryRoutes;